import React, { useState, useEffect } from 'react';
import { PageService } from '../../../Services/Axios/Api';
import { Card, Table, Button, Badge, Spinner, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';

const Pages = () => {
    const [pages, setPages] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedPage, setSelectedPage] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchPages();
    }, []);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const fetchPages = async () => {
        try {
            const response = await PageService.GetAllPages();
            if (response.isSuccess) {
                setPages(response.result);
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteClick = (page) => {
        setSelectedPage(page);
        setShowDeleteModal(true);
    };

    const handleDeleteConfirm = async () => {
        try {
            await PageService.DeletePage(selectedPage.slug);
            setShowDeleteModal(false);
            toast.success('Page deleted successfully');
            fetchPages();
        } catch (err) {
            setError(err.message);
        }
    };

    const handleEdit = (pageId, pageSlug , lang) => {
        navigate(`/bj-admin/pages/page-builder/${pageId}?slug=${pageSlug}&lang=${lang}`);
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                <Spinner animation="border" variant="primary" />
            </div>
        );
    }

    if (error) {
        return (
            <div className="alert alert-danger" role="alert">
                {error}
            </div>
        );
    }

    return (
        <div className="container-fluid py-4">
            <ToastContainer />
            <Card>
                <Card.Header className="d-flex justify-content-between align-items-center flex-wrap">
                    <h5 className="mb-2">Pages Management</h5>
                    <Button variant="primary" size="sm" onClick={() => navigate('/bj-admin/pages/page-builder')}>
                        <i className="fas fa-plus me-2"></i>
                        Add New Page
                    </Button>
                </Card.Header>
                <Card.Body>
                    <div className="table-responsive">
                        <Table hover className="align-middle">
                            <thead>
                                <tr>
                                    <th>Title</th>
                                    <th>Slug</th>
                                    <th>Description</th>
                                    <th>Status</th>
                                    <th>Created At</th>
                                    <th>Updated At</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {pages.map((page) => (
                                    <tr key={page.id}>
                                        <td>{page.title}</td>
                                        <td>{page.slug}</td>
                                        <td>{page.description}</td>
                                        <td>
                                            <Badge bg={page.isActive ? "success" : "danger"}>
                                                {page.isActive ? "Active" : "Inactive"}
                                            </Badge>
                                        </td>
                                        <td>{formatDate(page.createdAt)}</td>
                                        <td>{page.updatedAt?formatDate(page.updatedAt):'-'}</td>
                                        <td>
                                            <div className="d-flex gap-2">
                                                <Button 
                                                    variant="outline-primary" 
                                                    size="sm"
                                                    onClick={() => handleEdit(page.id , page.slug , page.language)}
                                                >
                                                    <i className="fas fa-edit"></i>
                                                </Button>
                                                <Button 
                                                    variant="outline-danger" 
                                                    size="sm"
                                                    onClick={() => handleDeleteClick(page)}
                                                >
                                                    <i className="fas fa-trash"></i>
                                                </Button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </Card.Body>
            </Card>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Are you sure you want to delete the page "{selectedPage?.title}"? This action cannot be undone and will delete all languages of this page.</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={handleDeleteConfirm}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default Pages;
